module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-8-f4d44b6e7209be268ec9ca334ee5ee9d.webp";